<ng-container [ngSwitch]="field.uiType" *transloco="let translate;">
    <ng-container *ngSwitchCase="'RADIOBUTTON'">
        <div class="row booleanFieldContainer radioGroup">
            <div class="col-6 booleanLabel !flex-1 !min-w-0 !truncate !max-w-fit " [title]="field.displayName || field.name">
                <span [textContent]="(field.displayName || field.name) + ' : '"></span>
            </div>
            <span *ngIf="required && field.message.errors?.length === 0" class="mat-form-field-subscript-wrapper requiredCls" [textContent]="'*' + translate('Required')"></span>
            <div class="col-6 booleanValues !max-w-[80px] !margin-right-[65px]">
                <mat-radio-button class="inputRadioButton margin5px" *ngFor="let option of options;" [value]="option.value" [checked]='checkIfRadioBtnSelected(option)' (change)='modelChange.emit(option.value)' [name]="field.displayName || field.name">
                    <span [textContent]="option.displayName"></span>
                </mat-radio-button>
            </div>
            <mat-error class="mat-form-field-subscript-wrapper requiredCls" *ngIf="field.message.errors?.length > 0" [title]="field.message.errors[0]">
                <span [textContent]="field.message.errors[0]"></span>
            </mat-error>
        </div>
    </ng-container>
    <ng-container *ngSwitchDefault>
        <material-select [disabled]="disabled" [options]="options" [placeholder]="field.displayName || field.name" [errors]="errors" [warnings]="warnings" [name]="field.displayName || field.name" [title]="field.displayName || field.name" [required]="required" [model]="field.value || fieldValue" [description]="description" (modelChange)="valueChanged($event)" [appearance]="appearance"></material-select>
    </ng-container>
</ng-container>
